import { Platform, StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  textFieldColor: {
    tintColor: Colors.blue_two,
    baseColor: Colors.warm_grey_two,
  },
  iconStyle: {
    marginBottom: 1,
    marginRight: 10,
    marginLeft: -5,
  },
  iconContainerStyle: isActive => ({
    backgroundColor: isActive ? Colors.vfRed : Colors.steel,
    height: 48,
    width: 48,
    right: 1,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    zIndex: -1,
  }),
  xIconStyle: {
    marginStart: 8,
    marginEnd: -12,
    marginVertical: 7.5,
  },
  xButtonStyle: {
    top: Platform.OS === 'android' ? 6.5 : 9,
    right: 5,
  },
  textInputStyle: {
    fontFamily: Fonts.type.VFFont,
    fontSize: 17,
    lineHeight: 17,
    height: 48,
    width: '100%',
  },
  textFieldInputContainerStyle: isActive => ({
    fontFamily: Fonts.type.VFFont,
    backgroundColor: Colors.white,
    borderRadius: 6,
    fontSize: 17,
    paddingBottom: Platform.OS === 'android' ? 9.5 : 12,
    paddingStart: 16,
    paddingEnd: 16,
    borderWidth: isActive ? 2 : 1,
    borderColor: isActive ? Colors.blue_four : Colors.white_two,
    lineHeight: 17,
    height: 48,
  }),
  searchStyle: {
    flexDirection: 'row',
  },
});
